export default __webpack_public_path__ + "static/media/user_responsive_profile.19c30db4.svg";